<script>
// import axios from "axios";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import { todoMethods, todoComputed } from "@/state/helpers";

import { tableData } from "../dataAdvancedtable";
import axios from 'axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

/**
 * Dashboard Component
 */
export default {

  page: {
    title: "Registración Masiva",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      checked: true,
     label: "",
      active: 1,
      dataOn: "On",
      dataOff: 'Off',


// ************************************** Link
      tableData: tableData,
      title: "Nueva Tarjeta",
      items: [
        {
          text: "Tarjetas",
          href: "/Tarjetas",
        },
        {
          text: "Nueva Tarjeta",
          active: true,
        },
      ],
      showModal: false,
      ultimo_folio: "",
      tarjeta:"",
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      empresas:[],
      municipios:[],
      puntos_entrega:[],
      lastFolio:'',
      objeto:{}
    };
  },

   computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length;
    },
  },

  mounted() {

    axios.get('https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/masivaScreen')
    .then((res) => {
      const {ultimo_folio="",empresas=[],municipios=[],puntos_entrega=[]} = res.data;
      this.lastFolio = ultimo_folio;
      this.empresas = empresas;
      this.municipios = municipios;
      this.puntos_entrega = puntos_entrega
    })

    this.checked = Boolean(this.active);
    // Podemos reutilizar la función update ya que el código es el mismo.
    this.update();

    this.fetchTodos();
    // Set the initial number of items
    this.totalRows = this.tableData.length;

    this.todoTotalRows = this.todos.length;

    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },

    methods: {

    update() {
      this.label = this.checked ? this.dataOn : this.dataOff;
    },
    ...todoMethods,
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },

    getColor (estado) {
        if (estado == "Activo") return 'red'
        else return 'green'
      },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },
    handleSubmit(){
      this.$swal.showLoading();
      axios.post('https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/masivaAdd',this.objeto)
      .then((res) => {
        this.$swal.hideLoading();
        const {response="",numero=""} = res.data;
        if (response === true) {
          this.$swal(
            'Registro',
            `${numero} nuevas tarjetas agregadas`,
            'success'
          );
          this.$router.push({name:'Tarjetas'});
        } else {
          this.$swal(
            'Alerta',
            'No se pudo agregar',
            'warning'
          );
        }
      })
      .catch(err =>{
        console.log(err);
        this.$swal(
          'Error',
          'Ocurrio un error',
          'error'
        );
      });
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <v-row>
        <v-col md="12">
          <v-card>
            <div class="card-body">
              <v-row>
                <v-col md="12">
                  <h4 class="card-title">Nueva Tarjeta</h4>
                </v-col>
                <v-col md="5">
                </v-col>
                <v-row>
                  <v-col md="8">
                    <b><label class="form-check-label " >Último folio creado</label> </b>
                    <div class="mb-4">
                      <b-form-input
                        v-model="lastFolio"
                        id="lastFolio"
                        placeholder="49999999"
                        disabled
                      ></b-form-input>
                    </div>          
                  </v-col> 
                  <v-col md="6">
                    <b> <label class="form-check-label " >Del Folio</label> </b>
                    <div class="mb-4">
                      <b-form-input
                        v-model="objeto.folio_inicio"
                        id="folioInicio"
                        placeholder="5000000"
                      ></b-form-input>
                    </div>
                  </v-col>  
                  <v-col md="6">
                    <b> <label class="form-check-label " >Al Folio</label> </b>
                    <div class="mb-4">
                      <b-form-input
                        v-model="objeto.folio_fin"
                        id="folioFin"
                        placeholder="5000000"
                      ></b-form-input>
                    </div>
                  </v-col>
                  <div class="row mb-4">
                  <div class="col-sm-12 col-md-4">
                    <b><label class="form-check-label">Fecha de entrega</label></b>
                    <div class="mb-4">
                      <b-form-input
                        v-model="objeto.fecha_entrega"
                        id="fecha_entrega"
                        type="date"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-2">
                    <b><label class="form-check-label">Hora de entrega</label></b>
                    <div class="mb-4">
                      <b-form-input
                        v-model="objeto.hora_entrega"
                        id="hora_entrega"
                        type="time"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4">
                    <b><label class="form-check-label">Fecha de compromiso de entrega</label></b>
                    <div class="mb-4">
                      <b-form-input
                        v-model="objeto.fecha_compromiso"
                        id="fecha_compromiso"
                        type="date"
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                  <v-col md="8">
                    <b><label class="form-check-label">Empresa, institución o dependencia</label></b>
                      <div class="mb-4">
                        <b-form-select
                          class="form-select"
                          v-model="objeto.id_empresa"
                          size="lg"
                        >
                          <option 
                            v-for="empresa in empresas" 
                            :key="empresa.id_empresa" 
                            :value="empresa.id_empresa"
                            >{{empresa.nombre}}
                          </option>
                        </b-form-select>
                      </div>
                  </v-col>  
                </v-row>
                <!-- <v-col md="8">
                  <b><label class="form-check-label " >Municipio</label></b>
                  <div class="mb-4">
                    <b-form-select
                      class="form-select"
                      v-model="objeto.id_municipio"
                      size="lg"
                    >
                      <option 
                        v-for="municipio in municipios" 
                        :key="municipio.id_municipio" 
                        :value="municipio.id_municipio"
                        >{{municipio.nombre}}
                      </option>
                    </b-form-select>
                  </div>
                </v-col> -->
                <!-- <v-col md="8">
                  <b><label class="form-check-label " >Punto de entrega</label></b>
                  <div class="mb-4">
                    <b-form-select
                      class="form-select"
                      v-model="objeto.id_punto_entrega"
                      size="lg"
                    >
                      <option 
                        v-for="punto in puntos_entrega" 
                        :key="punto.id_punto_entrega" 
                        :value="punto.id_punto_entrega"
                        >{{punto.nombre}}
                      </option>
                    </b-form-select>
                  </div>
                </v-col> -->
              <v-row>
                <v-col md="4">
                  <!-- <router-link to="/Tarjetas"> -->
                  <v-btn
                    color="success"
                    @click="handleSubmit()"
                  >
                    Guardar
                  </v-btn> 
                  <!-- </router-link> -->
                  <v-divider
                    class="mx-2"
                    inset
                    vertical
                  ></v-divider>
                  <router-link to="/Tarjetas">
                  <v-btn
                    color="secondary"
                  >
                    Cancelar
                  </v-btn>
                  </router-link>
                </v-col>
              </v-row>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </Layout>
</template>
